import { render, staticRenderFns } from "./StepBlock.vue?vue&type=template&id=66f60ffc&scoped=true&"
import script from "./StepBlock.vue?vue&type=script&lang=js&"
export * from "./StepBlock.vue?vue&type=script&lang=js&"
import style0 from "./StepBlock.vue?vue&type=style&index=0&id=66f60ffc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f60ffc",
  null
  
)

export default component.exports